module.exports = __webpack_public_path__ + "static/media/black-logo.4b7cc3d6.jpg";